module.exports = __webpack_public_path__ + "img/logo.477312de.png";